import React from 'react';

import iconCard from '../assets/images/card.png';
import iconQR from '../assets/images/qrcode.png';
import iconWalet from '../assets/images/wallet.png';
import visa from '../assets/images/visa.png';
import master from '../assets/images/mastercard.png';
import myDebit from '../assets/images/myDebit.png';
import duitNow from '../assets/images/duitnow.png';
import mpayWalet from '../assets/images/mpaywalet.png';
import grabPay from '../assets/images/grabpay.png';
import tng from '../assets/images/tng.png';
import aliPay from '../assets/images/alipay.png';
import mae from '../assets/images/mae.png';
import sPay from '../assets/images/spay.png';
import wechatPay from '../assets/images/wechatpay.png';
import boost from '../assets/images/boost.png';
import setel from '../assets/images/setel.png';
import pearl from '../assets/images/pearl.png';
import kits from '../assets/images/kits.png';
import cardBg from '../assets/svg/card_bg.svg';

function OurPaymentChannels() {
  const paymentMethod = [
    {
      icon: iconCard,
      name: "Credit And Debit Cards",
      desc: "Card payment with 1% MDR (Merchant Discount Rate)",
      logo: [visa, master, myDebit]
    },
    {
      icon: iconQR,
      name: "DuitNow QR",
      desc: "DuitNow QR payment with 1% MDR (Merchant Discount Rate)",
      logo: [duitNow]
    },
    {
      icon: iconWalet,
      name: "E-wallets",
      desc: "E-wallets payment with 1% -1.5% MDR (Merchant Discount Rate)",
      logo: [mpayWalet, grabPay, tng, aliPay, mae, sPay, wechatPay, boost, setel, pearl, kits]
    }
  ];

  return (
    <section className="py-12 px-4 md:py-16 px-2 bg-[#F6F6F7] md:-mb-1" id="home">
      <div className="container mx-auto max-w-6xl">
        <h1 className="text-4xl md:text-6xl font-bold my-6">
          Our Payment Channels
        </h1>
        <p className="text-gray-700 font-roboto mb-8 text-[23px]">
          VernPOS connects your business to a wide range of payment options, empowering customers to choose how they prefer to pay.
        </p>
      </div>
      <div className="flex flex-col md:flex-row mx-6 md:mx-auto max-w-6xl gap-6 text-left">
        {paymentMethod.map((method, index) => (
          <div className="card rounded-[17px] border-2 bg-white flex-1 hover:-translate-y-4 transition-transform duration-300" key={index}
            style={{backgroundImage: `url(${cardBg})`, backgroundPosition: 'center', backgroundSize: 'cover', 
                    backgroundRepeat: 'no-repeat'}}>
            <div className="card-body p-4">
              <img src={method.icon} alt="" className="w-6 h-6 mb-4" />
              <div className="font-semibold text-[18px] mb-4">
                {method.name}
              </div>
              <div className="text-[16px] mb-4">
                {method.desc}
              </div>
              <div className="font-sans">
                <ul className="flex flex-wrap gap-3 mb-4">
                  {method.logo.map((logoItem, i) => (
                    <li key={i} className="flex mb-1">
                      <img src={logoItem} alt="" className="max-h-max mb-1"/>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default OurPaymentChannels;